<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>产品管理</span>
                </div>
                <div class="title_desc">维护产品型号、名称和白底图。服务中心页面配置选择产品后会自动带入名称与图片，页面配置中不可手动修改。</div>
            </div>

            <div class="btn_box">
                <div class="btn_right_box">
                    <div class="button button2 add" @click="openCreate" v-if="roleCheck('103-104-102-102')">
                        <i class="el-icon-plus"></i>
                        <span>新增产品</span>
                    </div>
                </div>
            </div>

            <div class="product_grid" v-loading="loading">
                <div v-for="item in productList" :key="item.id" class="product_card">
                    <div class="product_img_box">
                        <img v-if="item.image" class="product_img" :src="item.image" alt="">
                        <div v-else class="product_img_empty">暂无图片</div>
                    </div>
                    <div class="product_info">
                        <div class="product_model">{{ item.model }}</div>
                        <div class="product_name">{{ item.name }}</div>
                        <div class="product_meta" v-if="item.countries && item.countries.length">国家：{{ item.countries.join(' / ') }}</div>
                        <div class="product_meta" v-if="item.languages && item.languages.length">语言：{{ formatLangs(item.languages) }}</div>
                    </div>
                    <div class="card_actions">
                        <div class="button text" @click="openEdit(item)" v-if="roleCheck('103-104-102-102')">编辑</div>
                        <div class="button text del_btn" @click="delItem(item)" v-if="roleCheck('103-104-102-102')">删除</div>
                    </div>
                </div>
                <div v-if="!loading && productList.length === 0" class="empty_hint">暂无产品，点击「新增产品」开始配置</div>
            </div>

            <Tip ref="tip" :msg="delMsg" @tipBack="delConfirm"></Tip>

            <!-- 新增/编辑弹窗 -->
            <Gh-Dialog size="big" ref="editDialog" :title="dialogMode === 'create' ? '新增产品' : '编辑产品'" @dialogBack="confirmSubmit">
                <template v-slot:cancel_btn>
                    <span></span>
                </template>
                <template v-slot:content>
                    <el-form label-width="110px" :model="editForm" style="max-width: 520px;">
                        <el-form-item label="产品型号" required>
                            <el-input v-model="editForm.model" placeholder="如 M1 Pro" :disabled="dialogMode === 'edit'" maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="产品名称" required>
                            <el-input v-model="editForm.name" placeholder="如 Neakasa M1 Pro 智能猫砂盆" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item label="白底图">
                            <div style="display:flex; align-items:center; gap:8px;">
                                <img v-if="editForm.image" class="img_preview" :src="editForm.image" alt="">
                                <upload ref="img_upload" :fileDire="uploadDire" :limit="1" @fileChange="fileChange">
                                    <template slot="desc">
                                        <span slot="tip" class="el-upload__tip upload_desc">{{ editForm.image ? '重新上传' : '上传白底图' }}</span>
                                    </template>
                                </upload>
                            </div>
                        </el-form-item>
                        <el-form-item label="适用国家">
                            <el-select v-model="editForm.countries" multiple filterable allow-create default-first-option placeholder="输入国家代码后回车，如 US" style="width: 100%;">
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用语言">
                            <el-select v-model="editForm.languages" multiple placeholder="请选择适用语言" style="width: 100%;">
                                <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
import upload from '../../../components/file/upload'
export default({
    name: 'psc-product-manage',
    data() {
        return {
            loading: false,
            productList: [],
            dialogMode: 'create',
            editForm: {
                id: '',
                model: '',
                name: '',
                image: '',
                countries: [],
                languages: []
            },
            delItemRow: null,
            delMsg: ''
        }
    },
    components: {
        upload
    },
    computed: {
        uploadDire() {
            return 'product-service-center/library/product'
        }
    },
    created() {
        this.loadList();
    },
    methods: {
        loadList() {
            this.loading = true
            this.api.pscProductList({}).then(res => {
                if (res.code === 200) {
                    this.productList = res.data.list || []
                } else {
                    this.productList = []
                }
                this.loading = false
            }).catch(() => {
                this.productList = []
                this.loading = false
            })
        },
        formatLangs(langs) {
            const names = langs.map(l => this.appData.lang[l] || l)
            return names.join(' / ')
        },
        resetForm() {
            this.editForm = {
                id: '',
                model: '',
                name: '',
                image: '',
                countries: [],
                languages: []
            }
        },
        openCreate() {
            this.dialogMode = 'create'
            this.resetForm()
            this.$refs.editDialog.show = true
            this.$nextTick(() => {
                if (this.$refs.img_upload) {
                    this.$refs.img_upload.init()
                }
            })
        },
        openEdit(row) {
            this.dialogMode = 'edit'
            this.editForm = {
                id: row.id,
                model: row.model,
                name: row.name,
                image: row.image || '',
                countries: (row.countries || []).slice(),
                languages: (row.languages || []).slice()
            }
            this.$refs.editDialog.show = true
        },
        fileChange(path, type) {
            if (type == 'upload') {
                this.editForm.image = 'https://jhc-en.oss-ap-southeast-1.aliyuncs.com/' + path
            } else {
                this.editForm.image = ''
            }
        },
        confirmSubmit() {
            if (!this.editForm.model) {
                this.$message.warning('请输入产品型号')
                return
            }
            if (!this.editForm.name) {
                this.$message.warning('请输入产品名称')
                return
            }
            if (this.dialogMode === 'create') {
                this.api.pscProductCreate({
                    model: this.editForm.model,
                    name: this.editForm.name,
                    image: this.editForm.image,
                    countries: this.editForm.countries,
                    languages: this.editForm.languages
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('新增成功')
                        this.$refs.editDialog.show = false
                        this.loadList()
                    } else {
                        this.$message.error(res.msg || '新增失败')
                    }
                })
            } else {
                this.api.pscProductUpdate({
                    id: this.editForm.id,
                    name: this.editForm.name,
                    image: this.editForm.image,
                    countries: this.editForm.countries,
                    languages: this.editForm.languages
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('更新成功')
                        this.$refs.editDialog.show = false
                        this.loadList()
                    } else {
                        this.$message.error(res.msg || '更新失败')
                    }
                })
            }
        },
        delItem(row) {
            this.delItemRow = row
            this.delMsg = '确认删除产品「' + row.model + '」？（已配置的页面引用不会自动清理）'
            this.$refs.tip.show = true
        },
        delConfirm() {
            if (!this.delItemRow) {
                return
            }
            this.api.pscProductDelete({ id: this.delItemRow.id }).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.loadList()
                } else {
                    this.$message.error(res.msg || '删除失败')
                }
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .title_desc {
        margin-top: 8px;
        color: #999;
        font-size: 13px;
    }
    .btn_right_box {
        text-align: right;
    }
    .product_grid {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        min-height: 120px;
        .product_card {
            width: 260px;
            border: 1px solid #E8E9F1;
            border-radius: 10px;
            padding: 16px;
            background: #fff;
            .product_img_box {
                width: 100%;
                height: 180px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #FAFBFD;
                border-radius: 8px;
                margin-bottom: 12px;
                overflow: hidden;
                .product_img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                }
                .product_img_empty {
                    color: #ccc;
                    font-size: 13px;
                }
            }
            .product_model {
                font-size: 16px;
                font-weight: 700;
                color: #333;
            }
            .product_name {
                font-size: 13px;
                color: #666;
                margin: 4px 0 6px;
                word-break: break-all;
            }
            .product_meta {
                font-size: 12px;
                color: #999;
                line-height: 20px;
            }
            .card_actions {
                display: flex;
                justify-content: flex-end;
                gap: 8px;
                margin-top: 10px;
                border-top: 1px solid #F2F3F8;
                padding-top: 10px;
            }
        }
        .empty_hint {
            width: 100%;
            text-align: center;
            color: #999;
            padding: 40px 0;
        }
    }
    .img_preview {
        width: 60px;
        height: 60px;
        object-fit: contain;
        border: 1px solid #E8E9F1;
        border-radius: 6px;
        background: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/product-manage.vue